import i18n from '@/i18n'
import { mapperToOptions } from '@/views/components/selects'

export default function(status) {
    const options = status.map(element => {
        return {
            ...element,
            name: i18n.t('status.' + element.name + '.name'),
            description: i18n.t('status.' + element.name + '.description'),
            color: {
                title: '',
                hex: element.color,
            },
        }
    })
    return mapperToOptions(options, undefined, 'name')
}
